import produce from 'immer';
import { ILikeThougthResponse, ISetMediaUpload, IThougthInitialState, types } from './types';
import { IGenericDocumentModifier, IThougth } from '../../types/global/helper';

const initialState: IThougthInitialState = {
    creatingThougth: false,
    gettingThougth: false,
    thougths: [],
};

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;
    switch (type) {
        case types.CREATE_THOUGTH:
            return produce(state, draft => {
                draft.creatingThougth = true;
            });
        case types.CREATE_THOUGTH_SUCCESS:
            return produce(state, draft => {
                draft.creatingThougth = false;
                draft.thougthInCreation = undefined;
                draft.selectedThougth = payload;
            });
        case types.CREATE_THOUGTH_FAIL:
            return produce(state, draft => {
                draft.creatingThougth = false;
                draft.thougthErrorMsg = payload;
            });
        case types.SET_UPLOAD_MEDIA:
            return produce(state, draft => {
                const { category, keyFile, thougth } = payload as ISetMediaUpload;
                if (thougth) draft.thougthInCreation = thougth;
                if (draft.thougthInCreation && category && keyFile) {
                    draft.thougthInCreation = {
                        ...draft.thougthInCreation,
                        [category]: [keyFile, ...(draft.thougthInCreation[category as keyof IThougth] as string[])],
                    };
                }
            });
        case types.DELETE_THOUGTH:
            return produce(state, draft => {
                draft.deletingThougth = true;
            });
        case types.DELETE_THOUGTH_SUCCESS:
            return produce(state, draft => {
                const { documentId } = payload as IGenericDocumentModifier;
                draft.thougths = draft.thougths?.filter(thougth => thougth._id !== documentId);
                draft.deletingThougth = false;
            });
        case types.DELETE_THOUGTH_FAIL:
            return produce(state, draft => {
                draft.thougthErrorMsg = payload;
                draft.deletingThougth = false;
            });
        case types.GET_ALL_THOUGTHS:
            return produce(state, draft => {
                draft.gettingThougth = true;
            });
        case types.GET_ALL_THOUGTHS_SUCCESS:
            return produce(state, draft => {
                draft.gettingThougth = false;
                draft.thougths = payload;
            });
        case types.GET_ALL_THOUGTHS_FAIL:
            return produce(state, draft => {
                draft.thougthErrorMsg = payload;
            });
        case types.UPLOAD_THOUGTH_MEDIA:
            return produce(state, draft => {
                draft.creatingThougth = true;
            });
        case types.UPLOAD_THOUGTH_MEDIA_SUCCESS:
            return produce(state, draft => {
                draft.creatingThougth = false;
            });
        case types.UPLOAD_THOUGTH_MEDIA_FAIL:
            return produce(state, draft => {
                draft.creatingThougth = false;
            });
        case types.UPDATE_THOUGTH:
            return produce(state, draft => {
                draft.loading = true;
            });
        case types.UPDATE_THOUGTH_SUCCESS:
            return produce(state, draft => {
                draft.loading = false;
            });
        case types.UPDATE_THOUGTH_FAIL:
            return produce(state, draft => {
                draft.loading = false;
                draft.thougthErrorMsg = payload;
            });

        case types.DELETE_A_THOUGTH_LIKE:
            return produce(state, draftState => {
                // const { additionalPayload } = payload as IGenericDocumentModifier;
                draftState.deletingLike = true;
                draftState.userInteraction = {
                    optimistic: true,
                };
                /** Handle for Activity Feed */
            });
        case types.DELETE_A_THOUGTH_LIKE_SUCCESS:
            return produce(state, draftState => {
                // const { additionalPayload } = payload as IGenericDocumentModifier;
                draftState.userInteraction = {
                    is_user_liked: false,
                    userLike: [],
                    optimistic: false,
                };
                draftState.deletingLike = false;
                /** handle in Activity Feeed */
            });
        case types.DELETE_A_THOUGTH_LIKE_FAIL:
            return produce(state, draftState => {
                draftState.deletingLike = false;
                draftState.userInteraction = {
                    optimistic: false,
                };
            });
        case types.LIKE_A_THOUGTH:
            return produce(state, draftState => {
                // const { thoughtId, like_category, like_type } = payload;
                draftState.liking = true;
                // const likedObject: IGenericLikeResponse = {
                //     _id: 'optimistic',
                //     like_category,
                //     user: 'optimistic',
                //     thougth: thoughtId,
                //     optimistic: true,
                //     created_at: 'optimistic',
                //     created_by: 'optimistic',
                //     like_type,
                // };
                draftState.userInteraction = {
                    optimistic: true,
                    is_user_liked: true,
                };
            });
        case types.LIKE_A_THOUGTH_SUCCESS:
            return produce(state, draftState => {
                const { data } = payload as ILikeThougthResponse;
                draftState.userInteraction = {
                    is_user_liked: true,
                    userLike: [data],
                    optimistic: false,
                };
                draftState.liking = false;
            });
        case types.LIKE_A_THOUGTH_FAIL:
            return produce(state, draftState => {
                // const { documentId } = payload;
                draftState.liking = false;
                draftState.userInteraction = {
                    optimistic: false,
                    is_user_liked: false,
                };
            });

        default:
            return state;
    }
};

export { reducer };
